import { render } from "./PimLabProductsOverview.vue?vue&type=template&id=37417e90&scoped=true&ts=true"
import script from "./PimLabProductsOverview.vue?vue&type=script&lang=ts"
export * from "./PimLabProductsOverview.vue?vue&type=script&lang=ts"

import "./PimLabProductsOverview.vue?vue&type=style&index=0&id=37417e90&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37417e90"]])

export default __exports__